import type { VersionnedStandardContent } from "src/app/contents/standard/textSetup";

export default {
  latest: {
    title: "Budget",
    content: () => <LatestBudgetContent />,
    options: { layout: "default" },
  },
} satisfies VersionnedStandardContent;

const LatestBudgetContent = () => (
  <iframe
    title="Tableau Metabase"
    src="https://metabase.immersion-facile.beta.gouv.fr/public/dashboard/dac7f422-0bca-411e-9dae-e2ca9701af8a"
    frameBorder="0"
    width="100%"
    height={800}
  />
);
